module.exports = __webpack_public_path__ + "static/img/ic_gy_fw_td.ee628817.png";